<mat-card class="main-wrapper">
  @if (dragAndDropEnabled && (!document || dragOver)) {
    <app-dropzone
      [variant]="dropzoneVariant"
    [ngClass]="dropzoneVariant"></app-dropzone>
  }
  @if (processing) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  }
  @if (document && !dragOver) {
    <mat-card-content [class.dragover]="dragOver"
      fileDragDrop
      (filesChangeEmiter)="onFileChange($event)"
      (dragOver)="setDragOver()"
      (dragLeave)="setDragLeave()">
      @if (showButtonBar || viewSwitcherVisible || validationStatusVisible) {
        <div class="viewer-toolbar" #viewerToolbar>
          <div class="toolbar-start">
            @if (buttonsToolbarVisible) {
              <ng-container [ngTemplateOutlet]="buttonsTpl"></ng-container>
            }
            @if (responsiveValidationStatusVisible) {
              <ng-container [ngTemplateOutlet]="validationTpl"></ng-container>
            }
          </div>
          @if (responsiveToolbarSearchVisible) {
            <div class="toolbar-center">
              <ng-container [ngTemplateOutlet]="searchTpl"></ng-container>
            </div>
          }
          @if (responsiveViewSwitcherVisible) {
            <div class="toolbar-end">
              <ng-container [ngTemplateOutlet]="viewSwitcherTpl"></ng-container>
            </div>
          }
          <div class="toolbar-overflow" [class.toolbar-overflow--active]="overflowActive">
            <button mat-icon-button color="primary"
                    [matMenuTriggerFor]="overflowMenu"
                    [disabled]="!overflowActive"
                    [matTooltip]="overflowTooltip"
                    [attr.aria-label]="overflowTooltip">
              <mat-icon class="symbol" svgIcon="more_vert"></mat-icon>
            </button>
          </div>
        </div>
      }

      <mat-menu #overflowMenu="matMenu" class="toolbar-overflow-menu" xPosition="before">
        <div class="toolbar-overflow-menu__content" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
          @if (searchInOverflow) {
            <ng-container [ngTemplateOutlet]="searchTpl"></ng-container>
          }
          @if (viewSwitcherInOverflow) {
            <ng-container [ngTemplateOutlet]="viewSwitcherTpl"></ng-container>
          }
          @if (validationInOverflow) {
            <ng-container [ngTemplateOutlet]="validationTpl"></ng-container>
          }
          @if (buttonsInOverflow) {
            <ng-container [ngTemplateOutlet]="buttonsTpl"></ng-container>
          }
        </div>
      </mat-menu>

      <ng-template #buttonsTpl>
        <div class="buttons">
          @if (configuration?.buttonBar?.uploadFile) {
            <button mat-icon-button color="primary" (click)="uploadClicked()" [matTooltip]="tooltip('cloud_upload')">
              <mat-icon class="symbol" svgIcon="cloud_upload"></mat-icon>
            </button>
          }
          @if (configuration?.buttonBar?.print && activeView !== 'pdf') {
            <button mat-icon-button color="primary" (click)="print()" [disabled]="printing" [matTooltip]="tooltip('print')">
              <mat-icon class="symbol" svgIcon="print"></mat-icon>
            </button>
          }
          @if (configuration?.buttonBar?.technicalDetails) {
            <button mat-icon-button color="primary" (click)="showTechnicalInformations()" [matTooltip]="tooltip('info')">
              <mat-icon class="symbol" svgIcon="info"></mat-icon>
            </button>
          }
          @if (validationButtonVisible) {
            <button mat-icon-button color="primary" (click)="triggerValidation()" [disabled]="validationState.status === 'validating'" [matTooltip]="tooltip('check')">
              <mat-icon class="symbol" svgIcon="check"></mat-icon>
            </button>
          }
          @if (configuration?.buttonBar?.zoomControls && activeView !== 'pdf') {
            <span class="separator"></span>
            <button mat-icon-button color="primary" (click)="zoomIn()" [matTooltip]="tooltip('zoom_in')">
              <mat-icon class="symbol" svgIcon="zoom_in"></mat-icon>
            </button>
            <button mat-icon-button color="primary" (click)="resetZoom()" [matTooltip]="tooltip('pageview')">
              <mat-icon class="symbol" svgIcon="pageview"></mat-icon>
            </button>
            <button mat-icon-button color="primary" (click)="zoomOut()" [matTooltip]="tooltip('zoom_out')">
              <mat-icon class="symbol" svgIcon="zoom_out"></mat-icon>
            </button>
          }
        </div>
      </ng-template>

      <ng-template #validationTpl>
        <div class="validation-badge validation-badge--{{ validationState.status }}"
             [class.validation-badge--clickable]="validationReportAvailable"
             [matTooltip]="validationBadgeTooltip"
             [matTooltipDisabled]="!validationBadgeTooltip"
             (click)="onValidationBadgeClick()">
          <div class="validation-badge__icon">
            @if (validationState.status === 'validating') {
              <mat-progress-spinner mode="indeterminate" [diameter]="20" [strokeWidth]="2.5"></mat-progress-spinner>
            } @else if (validationState.status === 'valid') {
              <mat-icon class="symbol" svgIcon="check"></mat-icon>
            } @else if (validationState.status === 'invalid') {
              <mat-icon class="symbol" svgIcon="error"></mat-icon>
            } @else {
              <mat-icon class="symbol" svgIcon="warning"></mat-icon>
            }
          </div>
          <div class="validation-badge__text">
            @if (validationState.status === 'validating') {
              <span class="validation-badge__title" i18n="@@einvoice.validation.status.validating">Validating…</span>
            }
            @if (validationState.status === 'valid') {
              @if (validationState.warningCount) {
                <span class="validation-badge__title" i18n="@@einvoice.validation.status.warnings">{validationState.warningCount, plural, =1 {1 warning · view report} other {{{ validationState.warningCount }} warnings · view report}}</span>
              } @else {
                <span class="validation-badge__title" i18n="@@einvoice.validation.status.valid">Valid</span>
              }
            }
            @if (validationState.status === 'invalid') {
              <span class="validation-badge__title" i18n="@@einvoice.validation.status.errors">{validationState.errorCount, plural, =1 {1 error} other {{{ validationState.errorCount }} errors}}</span>
            }
            @if (validationState.status === 'error') {
              <span class="validation-badge__title" i18n="@@einvoice.validation.status.failed">Validation failed</span>
            }
          </div>
          @if (formatLogoSrc || formatLabel) {
            <div class="validation-badge__format">
              @if (formatLogoSrc) {
                <img class="validation-badge__format-logo" [src]="formatLogoSrc" [alt]="formatLabel" />
              } @else {
                <span class="validation-badge__format-text">{{ formatLabel }}</span>
              }
            </div>
          }
        </div>
      </ng-template>

      <ng-template #searchTpl>
        <div class="search-toolbar">
          <div class="search-toolbar__field">
            <span class="search-toolbar__label" i18n="@@einvoice.viewer.search.label">Search</span>
            <input
              type="search"
              [value]="toolbarSearchQuery"
              (input)="setToolbarSearchQuery($any($event.target).value)"
              (keydown.enter)="submitToolbarSearch()"
              placeholder="Search in view"
              i18n-placeholder="@@einvoice.viewer.search.placeholder" />
            <button
              type="button"
              class="search-toolbar__mode"
              [class.search-toolbar__mode--active]="toolbarSearchExactMatch"
              [attr.aria-pressed]="toolbarSearchExactMatch"
              [attr.aria-label]="toolbarSearchExactMatchLabel"
              [matTooltip]="toolbarSearchExactMatchTooltip"
              matTooltipPosition="below"
              (click)="toggleToolbarSearchExactMatch()">
              <span class="search-toolbar__mode-icon" [class.search-toolbar__mode-icon--active]="toolbarSearchExactMatch" aria-hidden="true"></span>
            </button>
          </div>
          @if (toolbarSearchHasQuery) {
            <span class="search-toolbar__count">{{ toolbarSearchPosition }}</span>
            <button type="button" (click)="previousToolbarSearchResult()" [disabled]="!toolbarSearchCanNavigate" i18n="@@einvoice.viewer.search.previous">Previous</button>
            <button type="button" (click)="nextToolbarSearchResult()" [disabled]="!toolbarSearchCanNavigate" i18n="@@einvoice.viewer.search.next">Next</button>
          }
        </div>
      </ng-template>

      <ng-template #viewSwitcherTpl>
        <div class="view-switcher">
          <button mat-button color="primary" [class.active]="activeView === 'document'" (click)="setActiveView('document')" i18n="@@einvoice.viewer.view.document">Document</button>
          @if (pdfViewEnabled) {
            <button mat-button color="primary" [class.active]="activeView === 'pdf'" (click)="setActiveView('pdf')" i18n="@@einvoice.viewer.view.pdf">PDF</button>
          }
          @if (modelTreeViewEnabled) {
            <button mat-button color="primary" [class.active]="activeView === 'modelTree'" (click)="setActiveView('modelTree')" i18n="@@einvoice.viewer.view.model">Model</button>
          }
          @if (xmlViewEnabled) {
            <button mat-button color="primary" [class.active]="activeView === 'xml'" (click)="setActiveView('xml')" i18n="@@einvoice.viewer.view.xml">XML</button>
          }
        </div>
      </ng-template>


      <div
        class="viewer-surface"
        [class.viewer-surface--paper]="activeView === 'document'"
        [class.viewer-surface--pdf]="activeView === 'pdf'">
        @if (activeView === 'document' || preparingPrint) {
          <app-einvoice-document [document]="document" [additionalAttachments]="additionalAttachments" [filename]="filename" #einvoice
            [style.display]="activeView === 'document' ? null : 'none'"
            [style.zoom]="zoomLevelFactor"
            [class.dragover]="dragOver" (onError)="error($event)"></app-einvoice-document>
        }
        @if (pdfViewCreated) {
          <div class="retained-pdf-view" [hidden]="activeView !== 'pdf'" [attr.inert]="activeView !== 'pdf' ? '' : null">
            <app-einvoice-pdf-view [pdfBytes]="pdfBytes" [pdfFileName]="pdfFileName"></app-einvoice-pdf-view>
          </div>
        }
        @if (activeView === 'modelTree') {
          <app-einvoice-model-tree></app-einvoice-model-tree>
        }
        @if (activeView === 'xml') {
          <app-einvoice-xml-view></app-einvoice-xml-view>
        }
      </div>
    </mat-card-content>
  }
</mat-card>
